import axiosInstance from '@/utils/axios';
import { BannerApiResponse } from '@/types/banner_types';
import { TermsApiResponse } from '@/types/term_type';

// 배너 API 호출
export const getBanners = async () => {
  const { data } = await axiosInstance.get<BannerApiResponse>('/banners/category/TOP/');
  return data;
};

// 약관 API 호출
export const getTerms = async () => {
  const { data } = await axiosInstance.get<TermsApiResponse>('/terms/');
  if (data.success && data.data?.results) {
    return data.data.results;
  }
  return [];
};
